import React from 'react';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { actions as uploadDocumentAction } from '../../../../../redux/healthboard/requests/upload-document-req';
import { getFieldProps } from '../../../../../utils/fields/getFieldProps';
import SelectCustom from '../../../../SelectCustom';
import Button from '../../../../Button';
import { ViewDocuments } from '../ViewDocuments';
import { useUploadDocumentForm } from './useUploadDocumentForm';
import { VISIT_DOCUMENTS_TYPES } from './constants';
import styles from './index.styl';

export function AddDocumentForm({
  formatMessage,
  onClose,
  attachment,
  appointmentId,
  allowedDocumentCategories,
}) {
  const description = formatMessage({
    id: 'appointment.documents.description',
  });

  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(
      uploadDocumentAction.startUpload({
        ...formState,
        documents: attachment.file,
        appointmentId,
      }),
    );
    onClose();
  };

  const handleCancelButton = () => {
    clearForm();
    onClose();
  };

  const {
    formState,
    handleFormChange,
    clearForm,
    isValid,
    categoryOptions,
    subcategoryOptions,
    stateCategory,
    stateSubcategory,
  } = useUploadDocumentForm(attachment, allowedDocumentCategories);

  const makeField = getFieldProps(formatMessage, handleFormChange);

  return (
    <div className={styles.root}>
      <div className={styles.description}>{description}</div>
      <SelectCustom
        {...makeField(VISIT_DOCUMENTS_TYPES.CATEGORY)}
        needUpdateDefaultValue
        options={categoryOptions}
        value={stateCategory}
      />
      <SelectCustom
        {...makeField(VISIT_DOCUMENTS_TYPES.SUB_CATEGORY)}
        options={subcategoryOptions}
        needUpdateDefaultValue
        value={stateSubcategory}
      />
      <ViewDocuments attachment={attachment} singleView />
      <div className={styles.buttonWrapper}>
        <Button
          className={styles.buttonAction}
          raised
          color="primary"
          type="submit"
          onClick={handleSubmit}
          disabled={!isValid}
        >
          {formatMessage({ id: 'common.save' })}
        </Button>

        <Button
          className={styles.buttonAction}
          raised
          color="accent"
          onClick={handleCancelButton}
        >
          {formatMessage({ id: 'common.cancel' })}
        </Button>
      </div>
    </div>
  );
}

AddDocumentForm.propTypes = {
  formatMessage: PropTypes.func,
  onClose: PropTypes.func,
  attachment: PropTypes.object,
  appointmentId: PropTypes.number,
  allowedDocumentCategories: PropTypes.array,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitDocuments/AddDocumentForm/index.jsx